import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import routes from './routes'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/**
 * Hook for authorization module
 */
router.beforeEach((to, from, next) => {
  Vue.prototype.$layout = to.meta.layout || 'default'
  if (typeof to.meta.auth === 'undefined') to.meta.auth = true
  next()
})

export default router